/**
 * Migrates brand sections to include the new Color Palettes section
 * This ensures existing brands get the new section added after brand-colors
 */

export const migrateColorPalettesSection = (sections: any[]): any[] => {
  // Check if color-palettes section already exists
  const hasColorPalettes = sections.some(section => section.id === 'color-palettes');

  if (hasColorPalettes) {
    return sections; // Already has the section, no migration needed
  }

  // Find the index of brand-colors section
  const brandColorsIndex = sections.findIndex(section => section.id === 'brand-colors');

  if (brandColorsIndex === -1) {
    return sections; // No brand-colors section found, skip migration
  }

  // Create the new color-palettes section
  const colorPalettesSection = {
    id: 'color-palettes',
    title: 'Color Palettes',
    content: {
      paletteTitle: 'Color Palette',
      paletteDescription: 'Our color palette includes carefully crafted shades and tints for each brand color, providing flexibility for various design applications.',
      brandGuideline: '{{brandName}}/Brand Guideline',
      publishedDate: 'Published Date: {{publishedDate}}',
      brandUrl: 'visit: {{brandUrl}}',
      brandName: 'Brand Name'
    },
    styles: {
      backgroundColor: '#F8F9FA',
      textColor: '#333942',
      fontFamily: 'Helvetica',
      fontSize: '18px',
      padding: '60px',
      position: 'relative'
    },
    customization: {
      backgroundType: 'color',
      backgroundColor: '#F8F9FA',
      backgroundImage: '',
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      overlayEnabled: false,
      overlayColor: '#000000',
      overlayOpacity: 0,
      overlayBlendMode: 'normal'
    }
  };

  // Insert the new section right after brand-colors
  const newSections = [
    ...sections.slice(0, brandColorsIndex + 1),
    colorPalettesSection,
    ...sections.slice(brandColorsIndex + 1)
  ];

  return newSections;
};
